// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0px;
  margin: 0px;
}

body {
  font-family: "Montserrat", sans-serif;
}

.container {
  margin: 0 auto;
}

@media (max-width: 767px) {
  .container {
    padding: 0px 20px !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .container {
    max-width: 500px !important;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1150px !important;
  }
}

@media (min-width: 1600px) {
  .container {
    max-width: 1550px !important;
  }
}

@media (min-width: 1900px) {
  .container {
    max-width: 1700px !important;
  }
}

/* For Chrome, Safari, and Opera */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: #000 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* For Firefox */
input:-moz-autofill,
input:-moz-autofill:hover,
input:-moz-autofill:focus,
input:-moz-autofill:active {
  box-shadow: 0 0 0px 1000px white inset !important;
  -moz-text-fill-color: #000 !important;
}

/* For Edge */
input:-ms-autofill,
input:-ms-autofill:hover,
input:-ms-autofill:focus,
input:-ms-autofill:active {
  box-shadow: 0 0 0px 1000px white inset !important;
  -ms-text-fill-color: #000 !important;
}

/**** ToolTip css **********/
/* START TOOLTIP STYLES */
[tooltip] {
  position: relative; /* opinion 1 */
}

/* Applies to all tooltips */
[tooltip]::before,
[tooltip]::after {
  text-transform: none; /* opinion 2 */
  font-size: 0.9em; /* opinion 3 */
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  position: absolute;
  display: none;
  opacity: 0;
}
[tooltip]::before {
  content: "";
  /* border: 5px solid transparent;  */
  z-index: 1001; /* absurdity 1 */
}
[tooltip]::after {
  content: attr(tooltip); /* magic! */
  text-align: left;
  max-width: 200px;
  min-width: 200px;
  padding: 0px;
  border-radius: 0.3ch;
  background: #fff;
  z-index: 1000; /* absurdity 2 */
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid ccc;
  color: #5d5d5d;
  font-size: 14px;
  font-weight: 400;
  white-space: normal;
  line-height: normal;
  /* margin-left: -45px; */
}

.symplex-icon-wrap [tooltip]::after {
  min-width: 96px;
  max-width: 200px;
}

/* Make the tooltips respond to hover */
[tooltip]:hover::before,
[tooltip]:hover::after {
  display: block;
}

/* don't show empty tooltips */
[tooltip=""]::before,
[tooltip=""]::after {
  display: none !important;
}

/* FLOW: RIGHT */
[tooltip][flow^="right"]::after {
  min-width: 15em;
  top: 50%;
  /* left: calc(28% + 3px); */
  left: calc(13% + 3px);
  transform: translate(0.5em, -50%);
  min-width: 415px;
  padding: 20px;
}

/* FLOW: UP */
[tooltip]:not([flow])::before,
[tooltip][flow^="up"]::before {
  bottom: 100%;
  border-bottom-width: 0;
  /* border-top-color: #333; */
}
[tooltip]:not([flow])::after,
[tooltip][flow^="up"]::after {
  bottom: calc(100% + -10px);
}
[tooltip]:not([flow])::before,
[tooltip]:not([flow])::after,
[tooltip][flow^="up"]::before,
[tooltip][flow^="up"]::after {
  left: 67%;
  transform: translate(-50%, -0.5em);
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 9px;
}

/* FLOW: DOWN */
[tooltip][flow^="down"]::before {
  top: 100%;
  border-top-width: 0;
  border-bottom-color: #333;
}
[tooltip][flow^="down"]::after {
  top: calc(100% + 5px);
}
[tooltip][flow^="down"]::before,
[tooltip][flow^="down"]::after {
  left: 50%;
  transform: translate(-50%, 0.5em);
}

/* FLOW: LEFT */
[tooltip][flow^="left"]::before {
  top: 50%;
  border-right-width: 0;
  border-left-color: #333;
  left: calc(0em - 5px);
  transform: translate(-0.5em, -50%);
}

[tooltip][flow^="left"]::after {
  /* top: 50%; */
  right: calc(100% + 5px);
  transform: translate(-0.5em, -50%);
}

/* KEYFRAMES */
@keyframes tooltips-vert {
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes tooltips-horz {
  to {
    opacity: 1;
    transform: translate(0, -50%);
  }
}

/* FX All The Things */
[tooltip]:not([flow]):hover::before,
[tooltip]:not([flow]):hover::after,
[tooltip][flow^="up"]:hover::before,
[tooltip][flow^="up"]:hover::after,
[tooltip][flow^="down"]:hover::before,
[tooltip][flow^="down"]:hover::after {
  animation: tooltips-vert 300ms ease-out forwards;
}

[tooltip][flow^="left"]:hover::before,
[tooltip][flow^="left"]:hover::after,
[tooltip][flow^="right"]:hover::before,
[tooltip][flow^="right"]:hover::after {
  animation: tooltips-horz 300ms ease-out forwards;
}

/*********** Bootstrap tooltip css *****/
.tooltip-inner {
  background: #fff;
  box-shadow: 0px 3px 6px #00000029;
  color: #5d5d5d;
  font-size: 14px;
  z-index: 99;
  opacity: 1;
}

.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before,
.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #fff !important;
}

.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before,
.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #fff !important;
}

div#tooltip-right .tooltip-inner {
  max-width: 300px;
  text-align: left;
}

.tooltip.show {
  opacity: 1;
}

/****** postpaid toggle button css *****/
.postpaid-toggle-button .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.postpaid-toggle-button .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.postpaid-toggle-button .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.postpaid-toggle-button .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 1px;
  background-color: #fff;
  transition: 0.4s;
}

.postpaid-toggle-button input:checked + .slider {
  background-color: #00a19b;
}

.postpaid-toggle-button input:focus + .slider {
  box-shadow: 0 0 1px #00a19b;
}

.postpaid-toggle-button input:checked + .slider:before {
  transform: translateX(18px);
}

/* Rounded sliders */
.postpaid-toggle-button .slider.round {
  border-radius: 34px;
}

.postpaid-toggle-button .slider.round:before {
  border-radius: 50%;
}

.tooltip {
  --bs-tooltip-zindex: 99999;
}

@media (max-width: 1024px) {
  div#tooltip-right .tooltip-inner {
    max-width: var(--bs-tooltip-max-width);
    text-align: left;
  }
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,kCAAkC;AAClC;;;;EAKE,iDAAiD;EACjD,wCAAwC;EACxC,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,gBAAgB;AAChB;;;;EAIE,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA,aAAa;AACb;;;;EAIE,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B,yBAAyB;AACzB;EACE,kBAAkB,EAAE,cAAc;AACpC;;AAEA,4BAA4B;AAC5B;;EAEE,oBAAoB,EAAE,cAAc;EACpC,gBAAgB,EAAE,cAAc;EAChC,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa,EAAE,gBAAgB;AACjC;AACA;EACE,sBAAsB,EAAE,WAAW;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,aAAa,EAAE,gBAAgB;EAC/B,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;;EAEE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;;EAEE,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;AACf;;AAEA,aAAa;AACb;;EAEE,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;;;EAIE,SAAS;EACT,kCAAkC;EAClC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,SAAS;EACT,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA,sBAAsB;AACtB;;;;;;EAME,gDAAgD;AAClD;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sCAAsC;IACtC,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\n\n* {\n  padding: 0px;\n  margin: 0px;\n}\n\nbody {\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.container {\n  margin: 0 auto;\n}\n\n@media (max-width: 767px) {\n  .container {\n    padding: 0px 20px !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .container {\n    max-width: 500px !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1150px !important;\n  }\n}\n\n@media (min-width: 1600px) {\n  .container {\n    max-width: 1550px !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .container {\n    max-width: 1700px !important;\n  }\n}\n\n/* For Chrome, Safari, and Opera */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n  box-shadow: 0 0 0px 1000px white inset !important;\n  -webkit-text-fill-color: #000 !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* For Firefox */\ninput:-moz-autofill,\ninput:-moz-autofill:hover,\ninput:-moz-autofill:focus,\ninput:-moz-autofill:active {\n  box-shadow: 0 0 0px 1000px white inset !important;\n  -moz-text-fill-color: #000 !important;\n}\n\n/* For Edge */\ninput:-ms-autofill,\ninput:-ms-autofill:hover,\ninput:-ms-autofill:focus,\ninput:-ms-autofill:active {\n  box-shadow: 0 0 0px 1000px white inset !important;\n  -ms-text-fill-color: #000 !important;\n}\n\n/**** ToolTip css **********/\n/* START TOOLTIP STYLES */\n[tooltip] {\n  position: relative; /* opinion 1 */\n}\n\n/* Applies to all tooltips */\n[tooltip]::before,\n[tooltip]::after {\n  text-transform: none; /* opinion 2 */\n  font-size: 0.9em; /* opinion 3 */\n  line-height: 1;\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  display: none;\n  opacity: 0;\n}\n[tooltip]::before {\n  content: \"\";\n  /* border: 5px solid transparent;  */\n  z-index: 1001; /* absurdity 1 */\n}\n[tooltip]::after {\n  content: attr(tooltip); /* magic! */\n  text-align: left;\n  max-width: 200px;\n  min-width: 200px;\n  padding: 0px;\n  border-radius: 0.3ch;\n  background: #fff;\n  z-index: 1000; /* absurdity 2 */\n  box-shadow: 0px 3px 6px #00000029;\n  border: 1px solid ccc;\n  color: #5d5d5d;\n  font-size: 14px;\n  font-weight: 400;\n  white-space: normal;\n  line-height: normal;\n  /* margin-left: -45px; */\n}\n\n.symplex-icon-wrap [tooltip]::after {\n  min-width: 96px;\n  max-width: 200px;\n}\n\n/* Make the tooltips respond to hover */\n[tooltip]:hover::before,\n[tooltip]:hover::after {\n  display: block;\n}\n\n/* don't show empty tooltips */\n[tooltip=\"\"]::before,\n[tooltip=\"\"]::after {\n  display: none !important;\n}\n\n/* FLOW: RIGHT */\n[tooltip][flow^=\"right\"]::after {\n  min-width: 15em;\n  top: 50%;\n  /* left: calc(28% + 3px); */\n  left: calc(13% + 3px);\n  transform: translate(0.5em, -50%);\n  min-width: 415px;\n  padding: 20px;\n}\n\n/* FLOW: UP */\n[tooltip]:not([flow])::before,\n[tooltip][flow^=\"up\"]::before {\n  bottom: 100%;\n  border-bottom-width: 0;\n  /* border-top-color: #333; */\n}\n[tooltip]:not([flow])::after,\n[tooltip][flow^=\"up\"]::after {\n  bottom: calc(100% + -10px);\n}\n[tooltip]:not([flow])::before,\n[tooltip]:not([flow])::after,\n[tooltip][flow^=\"up\"]::before,\n[tooltip][flow^=\"up\"]::after {\n  left: 67%;\n  transform: translate(-50%, -0.5em);\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 9px;\n}\n\n/* FLOW: DOWN */\n[tooltip][flow^=\"down\"]::before {\n  top: 100%;\n  border-top-width: 0;\n  border-bottom-color: #333;\n}\n[tooltip][flow^=\"down\"]::after {\n  top: calc(100% + 5px);\n}\n[tooltip][flow^=\"down\"]::before,\n[tooltip][flow^=\"down\"]::after {\n  left: 50%;\n  transform: translate(-50%, 0.5em);\n}\n\n/* FLOW: LEFT */\n[tooltip][flow^=\"left\"]::before {\n  top: 50%;\n  border-right-width: 0;\n  border-left-color: #333;\n  left: calc(0em - 5px);\n  transform: translate(-0.5em, -50%);\n}\n\n[tooltip][flow^=\"left\"]::after {\n  /* top: 50%; */\n  right: calc(100% + 5px);\n  transform: translate(-0.5em, -50%);\n}\n\n/* KEYFRAMES */\n@keyframes tooltips-vert {\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n@keyframes tooltips-horz {\n  to {\n    opacity: 1;\n    transform: translate(0, -50%);\n  }\n}\n\n/* FX All The Things */\n[tooltip]:not([flow]):hover::before,\n[tooltip]:not([flow]):hover::after,\n[tooltip][flow^=\"up\"]:hover::before,\n[tooltip][flow^=\"up\"]:hover::after,\n[tooltip][flow^=\"down\"]:hover::before,\n[tooltip][flow^=\"down\"]:hover::after {\n  animation: tooltips-vert 300ms ease-out forwards;\n}\n\n[tooltip][flow^=\"left\"]:hover::before,\n[tooltip][flow^=\"left\"]:hover::after,\n[tooltip][flow^=\"right\"]:hover::before,\n[tooltip][flow^=\"right\"]:hover::after {\n  animation: tooltips-horz 300ms ease-out forwards;\n}\n\n/*********** Bootstrap tooltip css *****/\n.tooltip-inner {\n  background: #fff;\n  box-shadow: 0px 3px 6px #00000029;\n  color: #5d5d5d;\n  font-size: 14px;\n  z-index: 99;\n  opacity: 1;\n}\n\n.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\n.bs-tooltip-top .tooltip-arrow::before {\n  border-top-color: #fff !important;\n}\n\n.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\n.bs-tooltip-end .tooltip-arrow::before {\n  border-right-color: #fff !important;\n}\n\ndiv#tooltip-right .tooltip-inner {\n  max-width: 300px;\n  text-align: left;\n}\n\n.tooltip.show {\n  opacity: 1;\n}\n\n/****** postpaid toggle button css *****/\n.postpaid-toggle-button .switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n}\n\n.postpaid-toggle-button .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.postpaid-toggle-button .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.postpaid-toggle-button .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 1px;\n  background-color: #fff;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.postpaid-toggle-button input:checked + .slider {\n  background-color: #00a19b;\n}\n\n.postpaid-toggle-button input:focus + .slider {\n  box-shadow: 0 0 1px #00a19b;\n}\n\n.postpaid-toggle-button input:checked + .slider:before {\n  -webkit-transform: translateX(18px);\n  -ms-transform: translateX(18px);\n  transform: translateX(18px);\n}\n\n/* Rounded sliders */\n.postpaid-toggle-button .slider.round {\n  border-radius: 34px;\n}\n\n.postpaid-toggle-button .slider.round:before {\n  border-radius: 50%;\n}\n\n.tooltip {\n  --bs-tooltip-zindex: 99999;\n}\n\n@media (max-width: 1024px) {\n  div#tooltip-right .tooltip-inner {\n    max-width: var(--bs-tooltip-max-width);\n    text-align: left;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
